import { cn } from '@/lib/utils';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-md',
        'bg-gray-200 dark:bg-gray-700',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_1.5s_infinite]',
        'before:bg-gradient-to-r before:from-transparent before:via-gray-300/60 before:to-transparent',
        'dark:before:via-gray-500/40',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
